// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationsScreensNotificationsZone_wrapper"};